export default {
  importMarker: '订阅来源',
  fromFamily: '订阅运价',
  notFromFamily: '非订阅运价',
  title: '运价订阅',
  published: '被订阅的运价',
  companySearch: '搜索分享公司',
  groupSearch: '搜索分组',
  search: '搜索',
  all: '全部',
  subscribed: '已订阅',
  unsubscribed: '未订阅',
  loadFailed: '加载失败，请刷新重试',
  empty: '暂无公开运价',
  company: '分享公司',
  group: '运价分组',
  carrier: '承运人',
  dischargePortRoute: '卸货港航线',
  rates: '运价明细',
  shareTime: '最近分享时间',
  status: '订阅状态',
  pending: '待更新 {count} 条',
  subscriberCount: '订阅公司数',
  operations: '操作',
  details: '查看详情',
  subscribe: '订阅',
  update: '立即更新',
  cancel: '取消订阅',
  autoUpdate: '自动更新',
  autoHelp: '关闭后只提示待更新，手动更新仍可用',
  subscribers: '订阅公司',
  sourceStatus: '来源状态',
  available: '有效',
  unavailable: '已失效',
  localRate: '本地运价ID',
  syncResult: '同步结果',
  finalPrice: '最终分享价格',
  subscriptionPrice: '订阅价格',
  historyPriceMissing: '未记录这条运价的历史订阅价格，已导入的价格请到本地运价查看',
  yes: '是',
  no: '否',
  progress: '同步处理结果',
  result:
    '共 {total} 项，成功 {succeeded} 项，失败 {failed} 项；新增 {inserted}，覆盖 {updated}，下架 {offline}，无变化 {skipped}，保留 {retained}。',
  reason: '失败原因',
  noticePending: '结果通知待发送，不影响已导入运价',
  accepted: '已受理，请查看实际同步结果',
  cancelHelp: '取消后保留已导入运价，停止后续更新。确认取消整组订阅？',
  cancelled: '已取消订阅，保留 {count} 条已导入运价',
  singleSource: '资料未完善',
  lastSync: '最后成功同步时间',
  noChange: '已是最新，无需覆盖本地运价',
  labelMissing: '资料名称暂不可用',
  subscribeHelp:
    '分享公司：{company}；订阅范围：{group}，当前可导入 {count} 条运价。订阅后默认开启自动更新，后续新增及变更也会跟随整组。确认订阅？',
  states: {
    accepted: '等待处理',
    running: '处理中',
    succeeded: '处理成功',
    partialFailed: '部分失败',
    failed: '处理失败',
    cancelled: '已取消',
    pending: '待更新',
    synced: '已同步',
    following: '跟随更新',
    sourceInactive: '来源失效',
    retained: '保留停更',
    inserted: '新增',
    updated: '覆盖',
    offline: '下架',
    skipped: '无变化'
  },
  errors: {
    noSalesRule: '没匹配到 CargoWareX 销售规则，暂不能订阅此运价',
    supplierMissing: '请先在本公司维护代表分享公司的有效供应商，再重试',
    supplierAmbiguous: '分享公司匹配到多个供应商，请清理重复客商后重试',
    dataMatchFailed: '基础资料无法唯一匹配，请维护本公司基础资料后重试',
    snapshotInvalid: '公开版本已变化，请刷新后重试',
    groupUnavailable: '该组当前没有可订阅的公开运价',
    accessDenied: '当前人员没有订阅或运价维护权限',
    conflict: '设置或运行已变化，请刷新后重试',
    syncUnavailable: '同步暂时失败，请查看结果后重试'
  },
  fields: {
    airportId: '服务机场',
    destinationPortId: '目的港',
    loadingPortId: '装货港',
    loadingStationId: '装货站',
    destinationStationId: '目的站',

    pol: '起运节点',
    pod: '目的节点',
    por: '收货地',
    pdl: '交货地',
    carrierId: '船公司',
    airlineId: '航空公司',
    railCompanyId: '铁路公司',
    departureAirportId: '起飞机场',
    arrivalAirportId: '到达机场',
    departureStationId: '出发站',
    arrivalStationId: '到达站',
    dischargePortId: '卸货港',
    startAddress: '起运地址',
    destinationAddress: '目的地址',
    beginDate: '生效时间',
    endDate: '失效时间',
    vessel: '船名',
    voyage: '航次',
    etd: '预计开航',
    eta: '预计到达',
    flightNo: '航班号',
    railTrainNo: '班列号',
    voyageDays: '运输天数',
    voyageHours: '运输小时',
    loadMode: '装载模式',
    serviceType: '服务类型',
    routeType: '路线类型',
    priceMethod: '运输方式',
    billingModel: '计费模型',
    billingMethod: '计费方式',
    transportMode: '运输模式',
    remarks: '备注',
    overweightRemarks: '超重说明',
    receivingInstructions: '接货说明'
  },
  dimensions: {
    billingModel: {
      FIRST_ADDITIONAL: '首重+续重',
      UNIT_PRICE: '单价计费',
      WEIGHT_TIER: '重量段阶梯'
    },
    billingMethod: {
      WEIGHT: '按重量',
      VOLUME: '按体积',
      WEIGHT_VOLUME_MAX: '重量体积取大',
      TICKET: '按票'
    },

    loadMode: {
      EXPRESS: '快递',
      LTL: '零担',
      FTL: '整车'
    },
    routeType: {
      DOMESTIC: '国内',
      INTERNATIONAL: '国际',
      PENDING: '待定'
    },
    priceMethod: {
      '1': '直拖',
      '2': '支线',
      '3': '海铁'
    },
    serviceType: {
      express: '快递',
      standard: '标准',
      economy: '经济',
      priority_freight: '优先货运',
      economy_freight: '经济货运',
      deferred_freight: '延迟货运'
    }
  }
}
